import styled from 'styled-components';

export const TransferDetails = styled.div`
  & > *:last-child {
    margin-top: 30px;
  }
`;
